/* eslint-disable no-unused-vars */
// Keeping these unused variables so the meeting-header doesn't appear twice
define('meetings/meetings-header/meetings-header',['require','exports','module','durandal/app','knockout','plugins/router','api-access','scheduler/scheduler-container','invite-component/invite-component-container','popover-binder','i18next','web-urls','api-access','tagmanager','meeting-modal/gotomeet/personalize-meeting','api-access','mixpanel-helper','lodash','cookie-handler','bowser','notifications/trial-ending-marvel-notification/trial-ending-marvel-notification','meetings/lib/telemetry-client/telemetry-service','../embedded-launch','meetings/lib/start-meeting/start-meeting','react-join-form','meetings/upcoming-meetings/upcoming-meetings','web-urls'],function (require, exports, module) {
    /* eslint-enable */
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var meetingsApi = require('api-access').meetings;
    var Scheduler = require('scheduler/scheduler-container');
    var Invite = require('invite-component/invite-component-container');
    var popover = require('popover-binder');
    var i18n = require('i18next');
    var webUrls = require('web-urls');
    var userApi = require('api-access').user;
    var tagmanager = require('tagmanager');
    var personalizeMeeting = require('meeting-modal/gotomeet/personalize-meeting');
    var gotomeet = require('api-access').gotomeet;
    var mixpanelHelper = require('mixpanel-helper');
    var _ = require('lodash');
    var cookieHandler = require('cookie-handler');
    var bowser = require('bowser');
    var MarvelMessage = require('notifications/trial-ending-marvel-notification/trial-ending-marvel-notification');
    var telemetrySvc = require('meetings/lib/telemetry-client/telemetry-service');
    var embeddedLaunch = require('../embedded-launch');
    var startMeeting = require('meetings/lib/start-meeting/start-meeting').startMeeting;
    var JoinForm = require('react-join-form');

    /*
     * Pub/sub is necessary to update the current meeting and refresh the UI when meetings are joined.
     * The logic is contained in upcoming-meetings, which won't be composed on pages such as #past.
     * TODO: This piece of smelly code fixes that issue, at least until the meeting logic is properly consolidated.
     */
    require('meetings/upcoming-meetings/upcoming-meetings')();

    function meetingsHeader() {
        var self = this;
        var gotomeetMeUrl = webUrls.get('gotoMeetMeUrl');
        var baseUrl = webUrls.get('baseUrl');

        self.router = router;
        self.html5AppUrl = require('web-urls').get('html5AppUrl');

        self.gotomeetName = ko.observable(false);
        self.gotomeetProfile = ko.observable(false);
        self.gotomeetMeeting = ko.observable(false);
        self.gotomeetProfileUrl = ko.computed(function () {
            if (self.gotomeetProfile()) {
                return gotomeetMeUrl + '/' + self.gotomeetProfile().profileId;
            }
            return undefined;
        });
        self.bowser = bowser;

        self.isModalOpen = ko.observable(false);
        self.me = ko.observable();

        self.meetingInSession = ko.observable(false);
        self.upcomingMeetings = ko.observableArray();
        self.timeZone = ko.observable(false);

        // By default, Start meeting should by primary, and Share should be grey.
        // While in session, Share should be primary and End meeting should be grey.
        self.shareButtonClass = ko.pureComputed(function () {
            return self.meetingInSession() ? 'btn-primary' : 'btn-grey';
        });

        self.validate = function (input) {
            var validMeetingIdRegex = /^\d{3}-\d{3}-\d{3}$/;
            if (input && validMeetingIdRegex.test(input)) {
                return true;
            }
            return false;
        };

        self.joinMeeting = function (input) {
            var sessionTrackingId = telemetrySvc.getSessionTracking('mfe');
            var unformattedMeetingId = input.replace(/-/g, '');
            var sessionParam = sessionTrackingId ? '?sessionTrackingId=' + sessionTrackingId : '';
            var url = '/join/' + unformattedMeetingId + sessionParam;
            var properties = {
                ID: unformattedMeetingId
            };
            mixpanelHelper.trackLink(url, 'Join a Meeting', properties);

            telemetrySvc.report({
                ev_name: 'joinStart',
                sa_method: baseUrl + '::joining_meeting',
                ga_meetingId: input,
                ga_id_sessiontracking: sessionTrackingId
            });
        };

        self.reactJoinForm = ko.computed(function () {
            return {
                component: JoinForm.default,
                props: {
                    onJoinClick: self.joinMeeting,
                    validate: self.validate,
                    isJoinMeetingInitial: true,
                    t: i18n.t
                }
            };
        });

        app.on('meeting:in-session').then(function (meeting) {
            self.meetingInSession(meeting);
        });

        app.on('gotomeet:newSubject').then(function (meeting) {
            self.gotomeetName(meeting.subject);
            self.gotomeetMeeting(meeting);
        });

        app.on('gotomeet:profile').then(function (profile) {
            self.gotomeetProfile(profile);
        });

        self.showSessionInProgressBanner = function () {
            var banner = {
                id: 'session-in-progress',
                classes: 'alert-warning',
                iconClasses: 'togo-icon togo-icon-alert',
                title: i18n.t('myMeetings.sessionInProgress.header'),
                message: i18n.t('myMeetings.sessionInProgress.message'),
                removeOnNavigation: true
            };

            app.trigger('banner:add', banner);
        };

        self.isBrowserHtml5Compatible = function () {
            return bowser.chrome && bowser.version > 33;
        };

        self.scheduleMeeting = function () {
            popover.hide('#schedule-later', true);

            // todo: check if meetings exist
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                window.mixpanel.track('Open Schedule Meeting');

                userApi.settings().then(function (settings) {
                    var isRoom = settings.hasOwnProperty('roomsEnabled') && settings.roomsProvisioned && settings.roomsEnabled;
                    Scheduler.show(null, isRoom)
                        .then(function () {
                            self.isModalOpen(false);
                        })
                        .fail(function () {
                            self.isModalOpen(false);
                        });
                });
            }
        };

        self.showTrialEnding = function () {
            popover.hide('trial-ending-marvel-modal', true);
            // todo: check if meetings exist
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                mixpanelHelper.track('Open Trial Ending');

                var marvelModal = new MarvelMessage();
                marvelModal
                    .show()
                    .then(function () {
                        self.isModalOpen(false);
                    })
                    .fail(function () {
                        self.isModalOpen(false);
                    });
            }
        };

        self.meetNow = function () {
            popover.hide('#meet-now', true);
            meetingsApi
                .currentSession()
                .then(function () {
                    self.showSessionInProgressBanner();
                })
                .fail(function () {
                    var sessionTrackingId = telemetrySvc.getSessionTracking('mfe');
                    return userApi.settings().then(function (settings) {
                        var unsupportedOS = cookieHandler.get('unsupportedOS') === 'true';
                        var sessionParam = sessionTrackingId ? '?sessionTrackingId=' + sessionTrackingId : '';
                        var meetNowWithIJTelemetryEventData = {
                            ev_name: 'joinStart',
                            sa_method: baseUrl + '::meet_now_ij',
                            ga_meetingId: 'NA for meet now in browser',
                            ga_id_sessiontracking: sessionTrackingId
                        };
                        var isWebJoinFlow = settings.isWebJoinProvisioned && settings.isWebJoinEnabled;

                        // isWebJoinFlow will be true if web join flow is provisioned for the account and it is enabled for the user as well
                        // check for browser compatibility since this is organizer flow
                        // if compatible then web join flow else existing join flow

                        if (isWebJoinFlow && self.isBrowserHtml5Compatible()) {
                            telemetrySvc.report(meetNowWithIJTelemetryEventData);
                            window.location = '/meetNow' + sessionParam;
                        } else if (settings.nativeEndpointDisabled || unsupportedOS) {
                            if (self.isBrowserHtml5Compatible()) {
                                telemetrySvc.report(meetNowWithIJTelemetryEventData);
                                window.location = '/meetNow' + sessionParam;
                            } else {
                                window.location = '/unsupported-browser.html';
                            }
                        } else {
                            var meetingSettings = {
                                meetingType: 'impromptu',
                                subject: i18n.t('meeting.schedule.meetnow'),
                                video: {
                                    protocolVersion: '4'
                                }
                            };

                            return meetingsApi.create(meetingSettings).then(function (meeting) {
                                telemetrySvc.report({
                                    ev_name: 'joinStart',
                                    sa_method: baseUrl + '::meet_now_ep',
                                    ga_meetingId: meeting.meetingId,
                                    ga_id_sessiontracking: sessionTrackingId
                                });
                                tagmanager.gaEvent({
                                    category: 'My Meetings',
                                    action: 'Meet Now'
                                });
                                mixpanelHelper.track('Meet Now', {
                                    ID: meeting.meetingId
                                });
                                self.meetingInSession(meeting);
                                embeddedLaunch(meeting.meetingId, sessionTrackingId);
                            });
                        }
                        return undefined;
                    });
                });
        };

        self.shareMeeting = function (meetingId) {
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                Invite.show(meetingId)
                    .then(function () {
                        self.isModalOpen(false);
                    })
                    .fail(function () {
                        self.isModalOpen(false);
                    });
            }
        };

        // Warning: Analytics assumes this function is specifically for a GoToMeetMe meeting.
        self.startMeeting = function (meeting) {
            return startMeeting(meeting, { saMethod: 'starting_g2mm_meeting', isBrowserHtml5Compatible: self.isBrowserHtml5Compatible() });
        };

        self.endMeeting = function (meetingId) {
            router.navigate('');
            app.trigger('meeting:end', meetingId);
        };

        self.personalizeMeeting = function () {
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                mixpanelHelper.track('Open Personalize Meeting');
                personalizeMeeting
                    .show()
                    .then(function () {
                        self.isModalOpen(false);
                    })
                    .fail(function () {
                        self.isModalOpen(false);
                    });
            }
        };

        // create recurring meeting and update gotomeet with new meeting
        self.createGotomeetMeeting = function () {
            return userApi.me().then(function (me) {
                var meetingSettings = {
                    meetingType: 'recurring',
                    subject: me.firstName + ' ' + me.lastName
                };

                return meetingsApi.create(meetingSettings).then(function (meeting) {
                    var profileInfo = {
                        userKey: me.key,
                        meetingId: meeting.meetingId
                    };

                    return gotomeet.update(self.gotomeetProfile().profileId, profileInfo).done(function () {
                        // publish gotomeet.me meeting
                        app.trigger('gotomeet:meeting', meeting);

                        self.gotomeetName(meeting.subject);
                        self.gotomeetMeeting(meeting);
                    });
                });
            });
        };

        // Promise that resolves once the gotomeet header finishes composing.
        self.composeGoToMeetInfo = $.Deferred();

        self.activate = function () {
            /**
             * Two requests occur in parallel,
             * one to grab the gotomeetme profile, the other to grab the meeting list.
             *
             * If no G2MM meeting exists, it will be created.
             *
             * The activation only needs to block for the first request,
             * a small spinner over the meeting name will show while the other request is processing.
             */
            var activationPromise = $.Deferred();
            var gotomeetRequest = gotomeet.getByUserKey();
            var meetingRequest = meetingsApi.forOrganizerFormatted();

            gotomeetRequest
                .then(function (profile) {
                    if (profile.profileId) {
                        self.gotomeetProfile(profile);

                        meetingRequest.then(function (meetings) {
                            _.forEach(meetings, function (meeting) {
                                if (meeting.screenSharing) {
                                    self.meetingInSession(meeting);
                                    app.trigger('gotomeet:meeting', meeting);
                                }

                                if (meeting.meetingId === self.gotomeetProfile().meetingId) {
                                    // check if has meeting name, if not assign one
                                    if (!meeting.subject) {
                                        meeting.subject = i18n.t('meeting.schedule.title.default.text');
                                    }

                                    // publish gotomeet.me meeting
                                    app.trigger('gotomeet:meeting', meeting);

                                    self.gotomeetName(meeting.subject);
                                    self.gotomeetMeeting(meeting);
                                }
                            });

                            if (!self.gotomeetMeeting()) {
                                self.createGotomeetMeeting();
                            }
                        });
                    }
                })
                .fail(function () {
                    return meetingRequest.then(function (meetings) {
                        _.forEach(meetings, function (meeting) {
                            if (meeting.screenSharing) {
                                self.meetingInSession(meeting);
                            }
                        });
                    });
                })
                .always(function () {
                    if (window.location.hash && window.location.hash.indexOf('#schedule') === 0) {
                        self.scheduleMeeting();
                    }

                    if (window.location.hash && window.location.hash.indexOf('#sessionInProgress') === 0) {
                        self.showSessionInProgressBanner();
                    }

                    if (window.location.hash && window.location.hash.indexOf('#trialEnding') === 0) {
                        self.showTrialEnding();
                    }

                    self.composeGoToMeetInfo.resolve();
                });

            // The g2mm request will fail if g2mm is not set up. The module should activate regardless.
            gotomeetRequest.always(function () {
                activationPromise.resolve();
            });

            return activationPromise;
        };

        self.compositionComplete = function () {
            app.trigger('meetingsHeader:completedComposing');
        };
    }

    module.exports = meetingsHeader;
});

